import type { AxiosResponse } from 'axios';

import { apiClient } from '../../axios';
import {
  CsvApiType,
  GetConversionHistoryCsvParams,
  GetCsvParams,
  GetEarnHistoryCsvParams,
  GetExecutionHistoryCsvParams,
  GetFundingHistoryCsvParams,
  GetLaunchpoolHistoryCsvParams,
  GetOrderHistoryCsvParams,
  GetPnlHistoryCsvParams,
  GetPositionHistoryCsvParams,
  GetProfitBoostHistoryCsvParams,
  GetRewardHistoryCsvParams,
  GetWalletHistoryCsvParams,
  HistoryCsvResponse,
} from './types';

export const getConversionHistoryCsvApi = (params: GetConversionHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/conversion/history/csv', { params });

export const getEarnHistoryCsvApi = (params: GetEarnHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/earn/history/csv', { params });

export const getExecutionHistoryCsvApi = (params: GetExecutionHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/execution/history/csv', { params });

export const getOrderHistoryCsvApi = (params: GetOrderHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/order/history/csv', { params });

export const getFundingHistoryCsvApi = (params: GetFundingHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/funding/history/csv', { params });

export const getLaunchpoolHistoryCsvApi = (params: GetLaunchpoolHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/launchpool/history/csv', { params });

export const getProfitBoostHistoryCsvApi = (params: GetProfitBoostHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/profit-boost/history/csv', { params });

export const getPnlHistoryCsvApi = (params: GetPnlHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/pnl/csv', { params });

export const getPositionHistoryCsvApi = (params: GetPositionHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/position/history/csv', { params });

export const getRewardHistoryCsvApi = (params: GetRewardHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/referral-program/reward-history/csv', { params });

export const getWalletHistoryCsvApi = (params: GetWalletHistoryCsvParams) =>
  apiClient.get<HistoryCsvResponse>('/v1/wallet/history/csv', { params });

const csvApiMap: {
  [K in CsvApiType]: (params: GetCsvParams[K]) => Promise<AxiosResponse<HistoryCsvResponse>>;
} = {
  conversion: getConversionHistoryCsvApi,
  earn: getEarnHistoryCsvApi,
  execution: getExecutionHistoryCsvApi,
  order: getOrderHistoryCsvApi,
  funding: getFundingHistoryCsvApi,
  launchpool: getLaunchpoolHistoryCsvApi,
  'profit-boost': getProfitBoostHistoryCsvApi,
  pnl: getPnlHistoryCsvApi,
  position: getPositionHistoryCsvApi,
  reward: getRewardHistoryCsvApi,
  wallet: getWalletHistoryCsvApi,
};

export const getCsvApi = <T extends CsvApiType>(type: T, params: GetCsvParams[T]) => {
  return csvApiMap[type](params);
};
